import { useFormikContext } from "formik"
import { ISolution } from "../models/Solution"
import { Box, Typography } from "@mui/material"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"
import { ILayers, LayerType } from "../models/Layers"
import { ReactElement, Ref, useEffect, useRef, useState } from "react"
import {
  DragDropContext,
  Droppable,
  Draggable,
  DraggableProvidedDraggableProps,
  DraggableProvidedDragHandleProps,
} from "@hello-pangea/dnd"
import { Separator } from "./Separator"

export function LayerORdering(props: { layers: ILayers }): ReactElement {
  const setFieldValue = useFormikContext<ISolution>().setFieldValue
  const [layersMod, setLayersMod] = useState<ILayers>(props.layers)
  const layersRef = useRef(layersMod)

  useEffect(() => {
    layersRef.current = layersMod
  }, [layersMod])

  useEffect(() => {
    console.log("Mounted, got: ", layersMod)
    return () => {
      console.log("unmounted, setting vals: ", layersRef.current)
      setFieldValue("layers", layersRef.current)
    }
  }, []) //Empty dependencies, so effect runs only on mount

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const newItems = reorder(
      layersMod,
      result.source.index,
      result.destination.index
    )
    if (newItems) setLayersMod(newItems)
  }

  return (
    <>
      <Box height={`${layersMod.layersArr.length * 58 + 60}px`}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="Lol">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {layersMod.layersArr
                  .sort((a, b) => a.order - b.order)
                  .map((item: LayerType, index: number) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <DraggableItem
                          ref_={provided.innerRef}
                          draggableProps={provided.draggableProps}
                          dragHandleProps={provided.dragHandleProps}
                          item={item}
                          isDragging={snapshot.isDragging}
                        />
                      )}
                    </Draggable>
                  ))}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
      <Separator />
      <Typography fontSize="500" color="#250048">
        Total thickness: {layersMod.totalThicknes.toFixed(2)}mm
      </Typography>
      {/*TODO <ERRORS layers={layrrs}> viz better_fortes-196*/}
    </>
  )
}

function DraggableItem(props: {
  ref_: Ref<HTMLDivElement>
  draggableProps: DraggableProvidedDraggableProps
  dragHandleProps: DraggableProvidedDragHandleProps | null
  item: LayerType
  isDragging: boolean
}): ReactElement {
  return (
    <>
      <div
        ref={props.ref_}
        {...props.draggableProps}
        {...props.dragHandleProps}
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          border: props.isDragging ? "1px solid #250048" : "1px solid #dfe0f2",
          padding: "16px",
          margin: "0px 0px 15px 0px",
          userSelect: "none",
          ...props.draggableProps.style,
        }}
      >
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box display="flex" flexDirection="row" alignItems="center">
            <DragIndicatorIcon
              sx={{ margin: "0px 20px 0px 0px", color: "#250048" }}
            />
            <Typography color="#250048" fontWeight={500}>
              {props.item.name}
            </Typography>
          </Box>
          <Box>
            <Typography color="#aba3b9" fontWeight={500} fontSize="80%">
              thickness: {props.item.thickness.toFixed(2)} mm
            </Typography>
          </Box>
        </Box>
      </div>
    </>
  )
}

function reorder(
  layers: ILayers,
  source: number,
  destination: number
): ILayers | null {
  if (source === destination) return null
  else if (source < destination) {
    const newArr: Array<LayerType> = []
    layers.layersArr.forEach((l: LayerType) => {
      if (l.order > source && l.order <= destination) {
        newArr.push({ ...l, order: l.order - 1 })
      } else if (l.order === source) {
        newArr.push({ ...l, order: destination })
      } else {
        newArr.push({ ...l })
      }
    })
    return {
      layersArr: newArr,
      totalThicknes: layers.totalThicknes,
    }
  } else {
    const newArr: Array<LayerType> = []
    layers.layersArr.forEach((l: LayerType) => {
      if (l.order < source && l.order >= destination) {
        newArr.push({ ...l, order: l.order + 1 })
      } else if (l.order === source) {
        newArr.push({ ...l, order: destination })
      } else {
        newArr.push({ ...l })
      }
    })
    return {
      layersArr: newArr,
      totalThicknes: layers.totalThicknes,
    }
  }
}
